import React from "react"
import PropTypes from "prop-types"
import { withStyles } from "@material-ui/core/styles"

import Layout from "./layout"
import SEO from "./seo"
import KeymanDetail from "./keyman-detail"
import Banner from "./banner"
import OtherKeymans from "./other-keymans"
import BreadcrumbList from "./breadcrumb-list"
import { formatSeoProfile } from "../../utils/str"
import * as dayjs from "dayjs"
import ServiceDescription from "../atoms/service-description"
import LinkToLpText from "../atoms/link-to-lp-text"

const styles = theme => ({
})

const KeymanPage = ({
  keymansJson,
  keymans,
  departmentRankStats,
  getRankDepartmentsById,
  jsicSRankStats,
  getRankJsicSById,
  executiveCorporationTotal,
  executiveTotal,
}) => {
  const name = keymansJson.company_name
    ? `${keymansJson.company_name} ${keymansJson.name}`
    : keymansJson.name

  let breadcrumbList = [{ path: "/", text: "トップ" }]
  if (!!keymansJson.company_name && keymansJson.corporation_id) {
    breadcrumbList.push({
      path: `/corporations/${keymansJson.corporation_id}`,
      text: keymansJson.company_name,
    })
  }

  return (
    <Layout>
      <SEO
        title={`${name}`}
        description={formatSeoProfile(keymansJson)}
        canonical={`https://keyman-db.smart-letter.com/keymans/${keymansJson.id}`}
        meta={
          dayjs(keymansJson.relocation_at).isBefore("2018-01-01", "days")
            ? [
                {
                  name: `robots`,
                  content: "noindex",
                },
              ]
            : []
        }
      />
      <div className="container">
        <div className="list-container list-margin">
          <main className="left">
            <BreadcrumbList
              list={breadcrumbList}
              current={{
                path: `/keymans/${keymansJson.id}`,
                text: `${keymansJson.name}`,
              }}
              style={{ marginBottom: "12px" }}
            />
            <ServiceDescription
              children={<LinkToLpText/>}
            />
            <KeymanDetail
              item={keymansJson}
              keymansJson={keymansJson}
              departmentRankStats={departmentRankStats}
              getRankDepartmentsById={getRankDepartmentsById}
              jsicSRankStats={jsicSRankStats}
              getRankJsicSById={getRankJsicSById}
              executiveCorporationTotal={executiveCorporationTotal}
              executiveTotal={executiveTotal}
            />
          </main>

          <div className="right">
            <Banner short={true} />
            <OtherKeymans
              keymans={keymans}
              corporationId={keymansJson.corporation_id}
            />
          </div>
        </div>
      </div>
    </Layout>
  )
}

KeymanPage.propTypes = {
  classes: PropTypes.object.isRequired,
  keymansJson: PropTypes.object,
  keymans: PropTypes.array,
  departmentRankStats: PropTypes.object,
  getRankDepartmentsById: PropTypes.func.isRequired,
  jsicSRankStats: PropTypes.object,
  getRankJsicSById: PropTypes.func.isRequired,
}

export default withStyles(styles)(KeymanPage)
